<template>
  <header class="section-header">
    <div class="container-fluid">
        <div class="logo">
          <a href="/">
            <img src="/static/logo_zdp.svg">
          </a>
        </div>
        <div class="menu-button" @click="openMenu">
          <span class="menu-label">{{ $t('menu') }}</span>
          <div id="nav-icon" class="menu-open">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <nav id="menu">
          <div class="right">
            <ul class="main-nav part1">
              <li v-for="(item, index) in links">
                <a :href="int(item.url.path)" :class="isActive(item.url.path)" :key="index">{{ item.label }}</a>
              </li>
            </ul>
            <ul class="main-nav part2">
              <li v-for="(item, index) in main_menu">
                <a :href="int(item.url.path)" :class="isActive(item.url.path)" :key="index">{{ item.label }}</a>
              </li>
            </ul>
            <ul class="lang-switcher">
              <li><a @click="setLanguage('DE')">DE</a></li>
              <li><a @click="setLanguage('EN')">EN</a></li>
            </ul>
          </div>
        </nav>
    </div>
  </header>
</template>
<script>
  import $ from 'jquery';

  export default {
    components: {
      'loading-link': () => import('../atoms/LoadingLink'),
    },
    props: {
      links: {
        type: Object,
        default: () => [],
      },
      main_menu: {
        type: Object,
        default: () => [],
      },
      menu_content: {
        type: Object,
        default: () => [],
      },
    },
    data() {
      return {
        pre_scroll: 0,
        last_scroll: 0,
      }
    },
    methods: {
      openMenu: function(event) {
        event.preventDefault();
        event.stopPropagation();
        if(!$('.menu-button').hasClass('active')) {
          $('.menu-button').toggleClass('active');
          $('body').toggleClass('menu-open');
          if(window.innerWidth >= 768) {
            $(document).on('click', this.closeMenu);
          }
        } else {
          $('.menu-button').toggleClass('active');
          $('body').toggleClass('menu-open');
          $(document).off('click', this.closeMenu);
        }
      },
      closeMenu: function(event) {
        console.log(event);
        if($('.section-header').has(event.target).length === 0 && $('.menu-button').has(event.target).length === 0) {
          $('.menu-button').toggleClass('active');
          $('body').toggleClass('menu-open');
          $(document).off('click', this.closeMenu);
        }
      },
      scrolling: function() {
        if(this.last_scroll >= this.pre_scroll && $(window).scrollTop() > $('#section-hero').outerHeight()/2) {
          $('header').addClass('hidden');
        } else {
          $('header').removeClass('hidden');
        }
        this.pre_scroll = this.last_scroll;
        this.last_scroll = $(window).scrollTop();
      },
      isActive: function(link) {
        if(link.startsWith('/en')) {
          link = link.slice(3);
          if(window.location.pathname === link) {
            return 'active';
          }
        } else {
          if(window.location.pathname === link) {
            return 'active';
          }
        }
      },
      int: function(link) {
        if(link.startsWith('/en')) {
          link = link.slice(3);
          return link;
        } else {
          return link;
        }
      },
      setLanguage: function(langID) {
        if(this.$cookies.get('zdpLangCode')) {
          this.$cookies.remove('zdpLangCode');
          this.$cookies.set('zdpLangCode', langID);
        } else {
          this.$cookies.set('zdpLangCode', langID);
          this.$i18n.locale = langID.toLowerCase();
          this.$store.commit('setLanguage', langID.toLowerCase());
        }
        window.location.reload();
      },
    },
    created() {
      window.addEventListener('scroll', this.scrolling);
    },
  }
</script>
<style scoped lang="scss">
  @import "../../assets/scss/styles.scss";

  header.section-header {
    /*mix-blend-mode: difference;*/
    &.hidden {
      margin-top: -100px;
      transition: margin-top 0.2s ease-out;
    }
    opacity: 1;
    transition: all 0.2s ease 0s;
    left: 0;
    position:fixed;
    top: 0;
    width: 100%;
    z-index: 1500;
    color: #fff;
    padding: 10px 0;
    @include media-breakpoint-up(md) {
      padding: 20px 0;
    }
    display: flex;
    justify-content: space-around;
    align-items: center;
    .menu-button {
      float: right;
      margin-top: 7px;
      display: grid;
      cursor: pointer;
      grid-template-columns: 35px auto;
      @include media-breakpoint-up(md) {
      }
      &.active {
        z-index: 1000;
        .menu-label {
          z-index: 1000;
          content:'Schliessen';
        }
      }
      .menu-label {
        font-size:26px;
        display: none;
        margin-top: 0px;
        cursor: pointer;
        line-height: 1em;
        color: white;
        float: right!important;
        font-family: $headings-font-family;
        text-transform: uppercase;
        grid-auto-columns: 2/3;
        order: 2;
        @include media-breakpoint-up(md) {
          display: inline-block;
        }
      }
      #nav-icon {
        order: 1;
        grid-auto-columns: 1/2;
        cursor: pointer;
        display: inline;
        height: 14px;
        margin-left: 0px;
        padding: 0 14px;
        margin-top: 5px;
        position: relative;
        transform: rotate(0deg);
        transition: all 0.5s ease-in-out 0s;
        width: 28px;
        span {
          background: #fff none repeat scroll 0 0;
          display: block;
          height: 2px;
          left: 0;
          border-radius: 3px;
          opacity: 1;
          position: absolute;
          transform: rotate(0deg);
          transition: all 0.25s ease-in-out 0s;
          width: 100%;
          &:nth-child(1) { top: 0; }
          &:nth-child(2) { top: 6px; }
          &:nth-child(3) { top: 12px; }
        }
        &.menu-open {
          z-index: 1000;
        }
      }
    }
    .logo {
      float: left !important;
      z-index: 1000;
      position: relative;
      @include media-breakpoint-down(md) {
        img {
          width: 200px;
        }
      }
    }
  }
  //Open Menü
  .menu-open nav#menu {
    transform: translate(0%, 0%);
    z-index: 999;
  }
  .menu-open header.section-header .menu-button #nav-icon {
    span:nth-child(1) {
      top: 6px;
      transform: rotate(135deg);
    }
    span:nth-child(2) {
      left: -60px;
      opacity: 0;
    }
    span:nth-child(3) {
      top: 6px;
      transform: rotate(-135deg);
    }
  }
  /* Navigation Sidebar Styles */
  nav#menu {
    background-color:black;
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: 80%;
    border-left: 1px solid $dark;
    color: $gray-300;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    transform: translate(100%, 0%);
    transition: all 0.4s ease-in-out 0s;
    width: 100%;
    z-index: -1;
    overflow: scroll;
    overflow-x: auto;
    padding: 3*$grid-gutter-width $grid-gutter-width/2 2*$grid-gutter-width $grid-gutter-width/2;
    @include media-breakpoint-up(md) {
      width: 500px;
      padding: 3*$grid-gutter-width $grid-gutter-width*2 2*$grid-gutter-width $grid-gutter-width;
    }
    .top,.bottom {
      @include media-breakpoint-up(md) {
        padding: 0 $grid-gutter-width 0 $grid-gutter-width;
      }
    }
    ul.main-nav {
      list-style: outside none none;
      text-align: left;
      margin: 0 0 2*$spacer;
      padding: 0;
      li {
        a {
          color: white;
          display: block;
          border: none;
          text-decoration: none;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-image: linear-gradient(to right, $primary 50%, #ffffff 50%);
          background-repeat: no-repeat;
          background-size: 400% 400%;
          background-position: 67% center;
          transition: background-position 0.5s ease-in;
          font-size: $font-size-nav;
          cursor: pointer;
          &:hover, &.active {
            text-decoration: none;
            background-position: 33% center;
            transition: background-position 0.5s ease-in;
            &:before {
              opacity: 1;
              transition: opacity 0.5s ease-in;
            }
          }
          &:before {
            opacity: 0;
            content: '';
            width: 25px;
            height: 25px;
            margin-right: 10px;
            border: 3px solid $teal;
            background: $black;
            border-radius: 100%;
            display: inline-block;
            margin-top: 4px;
          }
          &.active {
            background-position: 33% center;
          }
        }
        ul {
          padding: 0;
          li {
            list-style: none;
            margin-left: 0;
            padding-left: 0;
            margin-bottom: 0;
            padding-bottom: 0;
            line-height: 1.2;
            a {
              color: $light;
              &:hover {
                -webkit-transform: translate(10px,0);
                transform: translate(10px,0);
                transition: 1s fade;
              }
              &:before {
                content: '→';
                color: transparent;
                margin-right: 7px;
              }
              &:hover {
                &:before {
                  content: '→';
                  color: $teal;
                }
              }
            }
          }
        }
      }
      &.part2 {
        a {
          color: $light;
          background-image: linear-gradient(to right, $primary 50%, $light 50%);
        }
      }
    }
    .lang-switcher {
      a {
        font-size: 28px;
      }
    }
    .menu-content {
      margin-top: 2*$grid-gutter-width;
      address {
        font-style: normal;
        a {
          color: white;
          text-decoration: none;
          border: none;
        }
      }
      h3 {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 4px;
        margin-top: 20px;
      }
      ul {
        list-style: outside none none;
        text-align: left;
        padding-left: 0;
        margin: 0;
      }
      span.side {
        bottom: 0;
        left: 30px;
        top: initial;
        transform: rotate(-90deg) translate(0%, 0px);
      }
    }
  }
  body.menu-open {
    overflow: hidden;
  }
</style>
